import React, { useEffect, useState } from 'react';

import { Accordion, Button, Icon, Input, Label, Image, Modal } from 'semantic-ui-react';
import { toast } from 'react-toastify';

import Switch from 'react-input-switch';
import Resize from "react-image-file-resizer";
import defaultIconWeb from '../../images/default_icon_web.png';
import withoutImage from '../../images/without_image.png';
import loader from '../../images/loader.gif';
import $ from "jquery";

function FavoriteTab(props) {
    const [stateModal, setStateModal] = useState("modify");
    const [modalItem, setOpenModalItem] = useState(false);
    const [modalConfirm, setOpenModalConfirm] = useState(false);
    const [modalGroup, setOpenModalGroup] = useState(false);
    const [switchDisabled, setValueSwitchDisabled] = useState(0);
    const [switchFooter, setValueSwitchFooter] = useState(0);
    const [groups, setGroups] = useState((props.favs === null) ? (localStorage.getItem('dataFavorite')) ? JSON.parse(localStorage.getItem('dataFavorite')) : [] : props.favs);
    const colorsDefault = ["black", "green", "orange", "pink", "purple", "red", "teal", "violet"];
    let colors = colorsDefault;

    const contentModalGroup = {
        es: { title: "Nuevo Grupo", errorText: "Grupo duplicado", inputPlaceholder: "Nombre del Grupo", btnRemove: "Eliminar", btnCancel: "Cancelar", btnSave: "Guardar" },
        us: { title: "New Group", errorText: "Duplicated group", inputPlaceholder: "Group Name", btnRemove: "Remove", btnCancel: "Cancel", btnSave: "Save" }
    }
    const contentModalItem = {
        es: { title: "Nuevo Elemento", errorText: "Extensión del archivo invalida (.png, .jpg, .jpeg)", inputPlaceholderName: "Nombre", inputPlaceholderLink: "Enlace URL", btnNewIcon: "Agregar icono", switchDisabled: "Deshabilitado", switchInFooter: "Mostrar en el pie de página", btnRemove: "Eliminar", btnCancel: "Cancelar", btnSave: "Guardar" },
        us: { title: "New Item", errorText: "Invalid extension file (.png, .jpg, .jpeg)", inputPlaceholderName: "Name", inputPlaceholderLink: "Link URL", btnNewIcon: "Add Icon Image", switchDisabled: "Disabled", switchInFooter: "Show in the footer", btnRemove: "Remove", btnCancel: "Cancel", btnSave: "Save" },
    }
    const contentConfirm = {
        es: { title: "Eliminar ", msg: "Estas seguro de que deseas eliminar este ", btnNo: "No", btnYes: "Si" },
        us: { title: "Delete ", msg: "Are you sure you want to delete the ", btnNo: "No", btnYes: "Yes" },
    }

    function handleChangeFavorites(updatedFav) {
        props.onChange(updatedFav);
    }

    function onFileResize(e) {
        const file = e.target.files[0];
        let nameFile = file.name.split(".");
        if (["png", "jpg", "jpeg"].indexOf(nameFile[nameFile.length - 1]) === -1) {
            $(".modal-item .input-name").addClass("error");
            $(".modal-item .msg").fadeIn(200);
            setTimeout(() => {
                $('.modal-item .msg').fadeOut(200);
            }, 3500);
        } else {
            Resize.imageFileResizer(
                file,
                64,
                64,
                "PNG",
                70,
                0,
                (uri) => {
                    $('.new-icon-image img').prop('src', uri);
                },
                "base64",
            );
        }
    }

    function saveChangesGroup() {
        let error = false;
        if ($(".modal-group .input-name input").val() === "") {
            $(".modal-group .input-name").addClass("error");
            error = true;
        }
        if (!error) {
            const index = $('.modal-group input[name="index"]').val();
            let title = $(".modal-group .input-name input").val();
            const key = title.replace(" ", "-").toLowerCase();
            let duplicated = false;
            for (const group of groups) {
                if (group.key === key) {
                    duplicated = true;
                    break;
                }
            }
            if (!duplicated) {
                let data = JSON.parse(localStorage.getItem('dataFavorite'));
                if (!data) {
                    data = [];
                }
                if (index === "-1") {
                    data.push({ title, key, items: [] });
                } else {
                    data[index].title = title;
                    data[index].key = key;
                }
                setOpenModalGroup(false);

                if (stateModal === "new") {
                    toast.success((props.lang === "es") ? 'Nuevo grupo creado' : 'Created new group', {
                        position: "top-center",
                        autoClose: 2500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                } else {
                    toast.success((props.lang === "es") ? 'Cambios guardados' : 'Changes saved', {
                        position: "top-center",
                        autoClose: 2500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
                sortJson(data);
                handleChangeFavorites(data);
                setGroups(data);
                localStorage.setItem("dataFavorite", JSON.stringify(data));
            } else {
                $(".modal-group .input-name").addClass("error");
                $(".modal-group .msg").fadeIn(200);
                setTimeout(() => {
                    $('.modal-group .msg').fadeOut(200);
                }, 2500);
            }
        }
    }

    function saveChangesItem() {
        let error = false;
        if ($(".input-name input").val() === "") {
            $(".input-name").addClass("error");
            error = true;
        }
        if ($(".input-link input").val() === "") {
            $(".input-link").addClass("error");
            error = true;
        }

        if (!error) {
            const data = JSON.parse(localStorage.getItem('dataFavorite'));
            for (const group of data) {
                if (group.title === $('.modal-item .group').text()) {
                    let index = $('.modal-item input[name="index"]').val();
                    if (index === "-1") {
                        index = group.items.length;
                    }
                    const title = $('.modal-item .input-name input').val();
                    const key = title.replace(" ", "-").toLowerCase();
                    const link = $('.modal-item .input-link input').val();
                    const icon = $('.modal-item .new-icon-image img').prop("src");
                    const inFooter = switchFooter;
                    const disabled = switchDisabled;
                    group.items[index] = { title, key, link, icon, inFooter, disabled };
                }
            }
            sortJson(data);
            handleChangeFavorites(data);
            setGroups(data);
            localStorage.setItem("dataFavorite", JSON.stringify(data));
            setOpenModalItem(false);
            if (stateModal === "new") {
                toast.success((props.lang === "es") ? 'Nuevo elemento creado' : 'Created new item', {
                    position: "top-center",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } else {
                toast.success((props.lang === "es") ? 'Cambios guardados' : 'Changes saved', {
                    position: "top-center",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    }

    function sortJson(json) {
        json.sort((a, b) => {
            return a.key - b.key;
        });
    }

    function onOpenGroupModal(item, index) {
        setOpenModalGroup(true);
        setTimeout(() => {
            setStateModal("new");
            $('.modal-group .input-name input').focus();
            if (item) {
                setStateModal("modify");
                $('.modal-group .input-name input').val(item.title);
            }
            $('.modal-group input[name="index"]').val(index);
        }, 1);
    }

    function onOpenItemModal(item, group, index) {
        setOpenModalItem(true);
        setTimeout(() => {
            setStateModal("new");
            $('.modal-item .input-name input').focus();
            if (item) {
                setStateModal("modify");
                setValueSwitchDisabled(item.disabled);
                setValueSwitchFooter(item.inFooter);
                $('.modal-item .input-name input').val(item.title);
                $('.modal-item .input-link input').val(item.link);
                $('.modal-item .old-icon-image img, .modal-item .new-icon-image img').prop("src", item.icon);
            } else {
                setValueSwitchDisabled(0);
                setValueSwitchFooter(0);
                $('.modal-item .old-icon-image img').prop("src", withoutImage);
                $('.modal-item .new-icon-image img').prop("src", defaultIconWeb);
            }
            $('.modal-item input[name="index"]').val(index);
            $('.modal-item .group').text(group);
        }, 1);
    }

    function onOpenConfirmModal(modal) {
        const skipIndex = $(`.modal-${modal} input[name="index"]`).val();
        let modalEs = "elemento";
        if (props.lang === "es" && modal === "group") {
            modalEs = "grupo";
        }
        if (skipIndex !== "-1") {
            setOpenModalConfirm(true);
            setTimeout(() => {
                let name = $(`.modal-${modal} .input-name input`).val();
                $(".modal-confirm .header").text(`${contentConfirm[props.lang].title} ${(props.lang === "es") ? modalEs : modal}`);
                $(".modal-confirm span.modal").text((props.lang === "es") ? modalEs : modal);
                $(".modal-confirm span.bold").text(name);
            }, 1);
        } else {
            setOpenModalGroup(false);
            setOpenModalConfirm(false);
            setOpenModalItem(false);
            toast.info((props.lang === "es") ? 'No se puede eliminar este ' + modalEs : "Can't be deleted this " + modal, {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    function removeItemFavorite() {
        const data = JSON.parse(localStorage.getItem('dataFavorite'));
        if (modalItem) {
            const group = $('.modal-item .group').text().replace(" ", "-").toLowerCase();
            const removeIndex = $('.modal-item input[name="index"]').val();
            for (const groupItem of data) {
                if (groupItem.key === group) {
                    groupItem.items.splice(removeIndex, 1);
                }
            }
        } else if (modalGroup) {
            const removeIndex = $('.modal-group input[name="index"]').val();
            data.splice(removeIndex, 1);
        }
        sortJson(data);
        handleChangeFavorites(data);
        setGroups(data);
        localStorage.setItem("dataFavorite", JSON.stringify(data));
        setOpenModalConfirm(false);
        setOpenModalItem(false);
        setOpenModalGroup(false);
        toast.success((props.lang === "es") ? 'Elemento eliminado' : "Item Removed", {
            position: "top-center",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    }

    function inputChange(ele) {
        $(ele).parent().removeClass("error");
    }

    useEffect(() => {
        setGroups((props.favs === null) ? (localStorage.getItem('dataFavorite')) ? JSON.parse(localStorage.getItem('dataFavorite')) : [] : props.favs);
    }, [props])

    return (
        <>
            <div id="tab-favorites" className="tab">
                <Accordion panels={groups.map((group, i) => {
                    colors = JSON.parse(JSON.stringify(colorsDefault));
                    let accordionsChild = group.items.map((item, j) => {
                        if (colors.length === 0) {
                            colors = colorsDefault;
                        }
                        const index = Math.floor(Math.random() * colors.length);
                        const selectedColor = colors[index];
                        colors.splice(index, 1);
                        return (
                            <Label key={j} as='a' color={selectedColor} tag onClick={() => onOpenItemModal(item, group.title, j)} >{item.title}</Label>
                        );
                    });
                    accordionsChild.push(
                        <div key={true} className="new-item-tag">
                            <Button primary className="new-item" onClick={() => onOpenItemModal(null, group.title, -1)} ><Icon name='tags' />{(props.lang === "es") ? 'Nuevo elemento' : 'New Item'}</Button>
                            <Button icon="edit" className="edit-group" onClick={() => onOpenGroupModal(group, i)} primary />
                        </div>);

                    group.content = {};
                    group.content.content = accordionsChild;

                    return group;
                })} />
                <Button secondary className="new-group" onClick={() => onOpenGroupModal(null, -1)} ><Icon name='add' /> {(props.lang === "es") ? 'Nuevo Grupo' : 'New Group'}</Button>
            </div>
            <Modal
                dimmer={"blurring"}
                onClose={() => setOpenModalItem(false)}
                open={modalItem}
                className="modal-item"
            >
                <Modal.Header>{contentModalItem[props.lang].title} (<span className="group"></span>)</Modal.Header>
                <Modal.Content image>
                    <p style={{ "display": "none" }} className="msg">{contentModalItem[props.lang].errorText}</p>
                    <Image className="old-icon-image" size='tiny' src={loader} wrapped />
                    <Icon name="angle double right" size="huge" />
                    <Image className="new-icon-image" size='tiny' src={loader} wrapped />
                    <Modal.Description>
                        <input type="hidden" name="index" />
                        <Input icon='address book' onChange={(e) => inputChange(e.target)} iconPosition='left' placeholder={contentModalItem[props.lang].inputPlaceholderName} className="input-name" />
                        <Input icon='linkify' onChange={(e) => inputChange(e.target)} iconPosition='left' placeholder={contentModalItem[props.lang].inputPlaceholderLink} className="input-link" />
                        <div className="box-file-switch">
                            <input style={{ display: "none" }} type="file" name="icon-file" id="icon-file" accept="image/*" onChange={onFileResize} />
                            <Label as='label' htmlFor="icon-file" color="blue">
                                <Icon name='image' />{contentModalItem[props.lang].btnNewIcon}
                            </Label>
                            <div className="switches">
                                <div>
                                    {contentModalItem[props.lang].switchDisabled} <Switch value={switchDisabled} onChange={setValueSwitchDisabled} />
                                </div>
                                <div>
                                    {contentModalItem[props.lang].switchInFooter} <Switch value={switchFooter} onChange={setValueSwitchFooter} />
                                </div>
                            </div>
                        </div>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content={contentModalItem[props.lang].btnRemove}
                        labelPosition='left'
                        className="remove"
                        icon='trash'
                        onClick={() => onOpenConfirmModal("item")}
                        negative
                    />
                    <Button
                        content={contentModalItem[props.lang].btnCancel}
                        labelPosition='right'
                        icon='close'
                        onClick={() => setOpenModalItem(false)}
                        negative
                    />
                    <Button
                        content={contentModalItem[props.lang].btnSave}
                        labelPosition='right'
                        icon='checkmark'
                        onClick={() => saveChangesItem()}
                        positive
                    />
                </Modal.Actions>
            </Modal>
            <Modal
                size="mini"
                open={modalConfirm}
                onClose={() => setOpenModalConfirm(false)}
                className="modal-confirm"
            >
                <Modal.Header className="header"></Modal.Header>
                <Modal.Content>
                    <p>{contentConfirm[props.lang].msg} <span className="modal"></span> <span className="bold"></span></p>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content={contentConfirm[props.lang].btnNo}
                        labelPosition='right'
                        icon='close'
                        onClick={() => setOpenModalConfirm(false)}
                        negative
                    />
                    <Button
                        content={contentConfirm[props.lang].btnYes}
                        labelPosition='right'
                        icon='checkmark'
                        onClick={() => removeItemFavorite()}
                        positive
                    />
                </Modal.Actions>
            </Modal>
            <Modal
                dimmer={"blurring"}
                size="tiny"
                open={modalGroup}
                onClose={() => setOpenModalGroup(false)}
                className="modal-group"
            >
                <Modal.Header>{contentModalGroup[props.lang].title}</Modal.Header>
                <Modal.Content>
                    <p style={{ "display": "none" }} className="msg">{contentModalGroup[props.lang].errorText}</p>
                    <input type="hidden" name="index" />
                    <Input icon='group' onChange={(e) => inputChange(e.target)} iconPosition='left' placeholder={contentModalGroup[props.lang].inputPlaceholder} className="input-name" />
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content={contentModalGroup[props.lang].btnRemove}
                        labelPosition='left'
                        className="remove"
                        icon='trash'
                        onClick={() => onOpenConfirmModal("group")}
                        negative
                    />
                    <Button
                        content={contentModalGroup[props.lang].btnCancel}
                        labelPosition='right'
                        icon='close'
                        onClick={() => setOpenModalGroup(false)}
                        negative
                    />
                    <Button
                        content={contentModalGroup[props.lang].btnSave}
                        labelPosition='right'
                        icon='checkmark'
                        onClick={() => saveChangesGroup()}
                        positive
                    />
                </Modal.Actions>
            </Modal>
        </>
    );
}

export default FavoriteTab;